import React, { createContext, useContext } from 'react';

const ProxyContext = createContext();

export const useProxyContext = () => useContext(ProxyContext);

export const BaseProxyProvider = ({ children, value }) => {
  return (
    <ProxyContext.Provider value={value}>{children}</ProxyContext.Provider>
  );
};
